import { render, staticRenderFns } from "./cms-block-slideshow.vue?vue&type=template&id=10a576e2&scoped=true"
import script from "./cms-block-slideshow.vue?vue&type=script&lang=js"
export * from "./cms-block-slideshow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a576e2",
  null
  
)

export default component.exports